export default {
    sniffdeck(state) {
        return state.sniffdeck;
    },
    mentionSuggestions(state) {
        return state.mentionSuggestions;
    },
    userFeedHistoryList(state) {
        return state.userFeedHistoryList;
    },
    settingLanguageList(state) {
        return state.settingLanguageList;
    },
}